import React from "react";
import LegalLayout from "./LegalLayout";

const P = ({ children }) => <p>{children}</p>;
const UL = ({ children }) => (
  <ul className="list-disc list-outside pl-6 space-y-2 marker:text-[#B08D57]">
    {children}
  </ul>
);

export default function Privacy() {
  return (
    <LegalLayout
      eyebrow="Legal"
      title="Privacy Policy"
      updated="February 2026"
      sections={[
        {
          id: "who-we-are",
          title: "1. Who we are",
          body: (
            <>
              <P>
                Prospera Financial Inc. ("<strong>Prospera</strong>", "we",
                "us") is a private financial-advisory practice incorporated
                in the Province of Ontario. Our head office is in Toronto.
              </P>
              <P>
                We collect and use personal information in the course of
                providing financial planning, life &amp; living-benefits
                insurance, and investment-account arrangements. This policy
                describes how we do so, and your rights, in accordance with
                Canada's <em>Personal Information Protection and Electronic
                Documents Act</em> (PIPEDA).
              </P>
            </>
          ),
        },
        {
          id: "what-we-collect",
          title: "2. What personal information we collect",
          body: (
            <>
              <P>Depending on the service, we may collect:</P>
              <UL>
                <li>
                  Identity &amp; contact information: name, address, phone,
                  email, date of birth, SIN (only where legally required).
                </li>
                <li>
                  Financial information: income, assets, liabilities,
                  existing coverage, corporate holdings, beneficiaries.
                </li>
                <li>
                  Health and lifestyle information (for underwriting): height,
                  weight, medical history, tobacco use.
                </li>
                <li>
                  Family information: spouse and dependants necessary for
                  planning.
                </li>
                <li>
                  Website and communications information: pages visited, form
                  submissions, correspondence.
                </li>
              </UL>
            </>
          ),
        },
        {
          id: "how-we-use",
          title: "3. How we use it",
          body: (
            <>
              <UL>
                <li>To provide financial-planning and advisory services.</li>
                <li>
                  To transact with insurance carriers, mutual-fund dealers, and
                  regulated third parties on your behalf.
                </li>
                <li>
                  To meet our regulatory obligations (Know-Your-Client, anti-
                  money-laundering, suitability, complaint handling).
                </li>
                <li>To communicate with you and answer your questions.</li>
                <li>To send you newsletters or updates you have opted into.</li>
              </UL>
              <P>
                We do <strong>not</strong> sell personal information. We share
                only what is necessary with regulated carriers, custodians,
                accountants and legal counsel with your knowledge or consent.
              </P>
            </>
          ),
        },
        {
          id: "cookies",
          title: "4. Cookies & analytics",
          body: (
            <P>
              Our website uses only strictly-necessary cookies for
              session state (e.g. keeping you signed into the advisor
              console). We do not employ third-party ad tracking. Simple
              server-side analytics may record aggregate traffic patterns; no
              individual is identified by these logs.
            </P>
          ),
        },
        {
          id: "retention",
          title: "5. Retention",
          body: (
            <P>
              Client records are retained for the greater of (a) the period
              required by the applicable regulator (typically seven years
              after account or policy termination) and (b) any period
              reasonably required to meet legal or tax obligations. After
              that, records are securely destroyed.
            </P>
          ),
        },
        {
          id: "your-rights",
          title: "6. Your rights",
          body: (
            <>
              <P>Under PIPEDA you have the right to:</P>
              <UL>
                <li>Ask what personal information we hold about you.</li>
                <li>Request corrections to inaccurate information.</li>
                <li>
                  Withdraw consent to marketing communications at any time
                  (some communications are required by regulation and cannot
                  be opted out of).
                </li>
                <li>Complain to our Privacy Officer or to the OPC.</li>
              </UL>
            </>
          ),
        },
        {
          id: "contact",
          title: "7. Privacy Officer",
          body: (
            <>
              <P>
                Send privacy requests to <strong>Biagio DiGirolamo,
                Privacy Officer</strong>, at{" "}
                <a
                  href="mailto:info@prosperafinancial.ca"
                  className="text-[#8A6A2E] underline underline-offset-2"
                >
                  info@prosperafinancial.ca
                </a>
                . Written correspondence: Prospera Financial Inc., Toronto,
                Ontario.
              </P>
              <P>
                You may also contact the <strong>Office of the Privacy
                Commissioner of Canada</strong> at 1-800-282-1376 or{" "}
                <a
                  href="https://www.priv.gc.ca"
                  className="text-[#8A6A2E] underline underline-offset-2"
                >
                  priv.gc.ca
                </a>
                .
              </P>
            </>
          ),
        },
      ]}
    />
  );
}
